import * as React from 'react';
import Select from '../select';
const MiniSelect = props => <Select size="small" {...props}/>;
MiniSelect.Option = Select.Option;
export default MiniSelect;
